import { AppState } from 'common/store/store';
import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useSelector } from 'react-redux';

export default (props: { children: React.ReactNode; }) => {
    const key = useSelector((state: AppState) => state.recaptcha.key);
    return <GoogleReCaptchaProvider
        reCaptchaKey={key}
        language="frCA"
        useEnterprise={true}
        scriptProps={{
            async: false, // optional, default to false,
            defer: false, // optional, default to false
            appendTo: 'head', // optional, default to "head", can be "head" or "body",
            nonce: undefined // optional, default undefined
        }}
    >
        {props.children}
    </GoogleReCaptchaProvider>;
};
